// cardsConfig.js
export const STORE_MAIN_SERVICES = [
  {
    id: "DigitalOrdering",
    key: "DigitalOrdering",             // maps to REST payload key
    label: "Digital Ordering",
    modal: true,                        // <-- open modal directly
    storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName,  degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='digitalordering' AND ( tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='digitalordering' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "Sesame",
    key: "Sesame",
    label: "Sesame",
    modal: true,                        // <-- open modal directly
    storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
       `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='sesame' AND ( tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' )AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='sesame' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "eProd",
    key: "eProd",                       // exact match to REST key
    label: "Eprod",
    modal: true,                        // <-- open modal directly
     storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='eprod' AND (tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='eprod' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "MyStore",
    key: "MyStore",
    label: "Mystore",
    modal: true,                        // <-- open modal directly
     storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='mystore' AND ( tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='mystore' LIMIT MAX)  since 30 days ago LIMIT MAX`
  }
];


// cardsConfig.js
export const SERVICE_MAIN_SERVICES = [
  {
    id: "DigitalOrdering",
    key: "DigitalOrdering",             // maps to REST payload key
    label: "Digital Ordering",
    modal: true,                        // <-- open modal directly
    storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='digitalordering' AND (tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='digitalordering' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "Sesame",
    key: "Sesame",
    label: "Sesame",
    modal: true,                        // <-- open modal directly
    storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
       `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='sesame' AND (tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='sesame' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "eProd",
    key: "eProd",                       // exact match to REST key
    label: "Eprod",
    modal: true,                        // <-- open modal directly
     storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='eprod' AND (tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='eprod' LIMIT MAX)  since 30 days ago LIMIT MAX`
  },
  {
    id: "MyStore",
    key: "MyStore",
    label: "Mystore",
    modal: true,                        // <-- open modal directly
     storeId: (storeId) => storeId,
    modalQuery: (storeId) =>
      `SELECT incidentId, conditionName, degradationTime, openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group ='mystore' AND (tags.Store  = '${storeId}' OR  tags.store.number = '${storeId}' ) AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group ='mystore' LIMIT MAX)  since 30 days ago LIMIT MAX`
  }
];
